var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useRef } from "react";
import { TextArea } from "@atlassiansox/microscopekit";
import { ErrorMessage, HelperMessage, ValidMessage } from "@atlaskit/form";
import { isEqual } from "lodash";
export var JsonInput = function (_a) {
    var name = _a.name, value = _a.value, onChange = _a.onChange, label = _a.label, placeholder = _a.placeholder, _b = _a.isRequired, isRequired = _b === void 0 ? false : _b;
    var _c = useJsonInputState(value, onChange), text = _c.text, setText = _c.setText;
    return (React.createElement(React.Fragment, null,
        React.createElement(TextArea, { name: name, value: text, label: label, isRequired: isRequired, onChange: function (e) {
                setText(e.target.value);
            }, placeholder: placeholder, minimumRows: 6, isMonospaced: true }),
        React.createElement(ValidationMessage, { text: text }),
        React.createElement(DocumentationMessage, null)));
};
var DocumentationMessage = function () { return (React.createElement(HelperMessage, null,
    "Refer this \u00A0",
    React.createElement("a", { href: "https://developer.atlassian.com/platform/brahmos/application/wiremock/" }, "documentation"),
    " ",
    "\u00A0 for fault configuration")); };
var ValidationMessage = function (_a) {
    var text = _a.text;
    if (!text) {
        return React.createElement(HelperMessage, null, "Please enter valid JSON input");
    }
    if (!isValidJsonText(text)) {
        return React.createElement(ErrorMessage, null, "Invalid JSON");
    }
    return React.createElement(ValidMessage, null, "JSON is valid");
};
var useJsonInputState = function (value, onChange) {
    var _a = __read(useState(""), 2), text = _a[0], setText = _a[1];
    var textRef = useRef(text);
    useEffect(function () {
        textRef.current = text;
    }, [text]);
    useEffect(function () {
        if (!isEqual(value, getValue(textRef.current))) {
            setText(getText(value));
        }
    }, [value]);
    var onChangeRef = useRef(onChange);
    useEffect(function () {
        onChangeRef.current = onChange;
    }, [onChange]);
    useEffect(function () {
        var newValue = getValue(text);
        if (newValue) {
            onChangeRef.current(newValue);
        }
    }, [text]);
    return {
        text: text,
        setText: setText
    };
};
var isValidJsonText = function (text) {
    var value;
    try {
        value = JSON.parse(text);
    }
    catch (_a) {
        return false;
    }
    return typeof value === "object";
};
var getText = function (value) {
    if (!value || typeof value !== "object") {
        return "";
    }
    var text;
    try {
        text = JSON.stringify(value, null, 2);
    }
    catch (_a) {
        return "";
    }
    return text;
};
var getValue = function (text) {
    if (!isValidJsonText(text)) {
        return null;
    }
    return JSON.parse(text);
};
